// extracted by mini-css-extract-plugin
export default {"container":"BackButton_container__5uiXz","backButtonContent":"BackButton_backButtonContent__SC+kw"};